import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTable, MatTableDataSource, MatTableModule} from "@angular/material/table";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatSortModule} from "@angular/material/sort";
import {environment} from "../../../environments/environment";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ToolType} from "allai-admin-shared";
import {PageLoaderService} from "../../services/page-loader.service";
import {FormsModule} from "@angular/forms";

@Component({
	selector: 'app-tools',
	imports: [
		MatTableModule,
		MatIconModule,
		MatButtonModule,
		MatSortModule,
		FormsModule
	],
	templateUrl: './tools.component.html',
	styleUrl: './tools.component.scss'
})
export class ToolsComponent implements OnInit {

	/** Columns in the table */
	readonly displayedColumns:(keyof ToolRow | 'run')[] = ['name', 'run'];

	/** Data source for the table */
	dataSource:MatTableDataSource<ToolRow>;
	tools:ToolRow[];

	@ViewChild(MatTable)
	private table:MatTable<ToolRow>;

	protected textAreaValue: string ="";

	resultsVisible = false;

	constructor(private http:HttpClient, private pageLoaderService: PageLoaderService) {
	}

	ngOnInit() {
		this.tools = [
			{name: 'Create Surveys for Appointments Job', type: ToolType.CreateSurveysForAppointments},
		]
		this.dataSource = new MatTableDataSource<ToolRow>(this.tools);
		this.table?.renderRows();
	}

	protected async runTool(tool: ToolRow) {
		this.textAreaValue = "";
		this.pageLoaderService.show(`Running ${tool.name}...`);
		this.resultsVisible = true;
		try {
			const response = await firstValueFrom(this.http.post<any>(`${environment.apiUrl}/tools/${tool.type}`, {}));
			this.textAreaValue = JSON.stringify(response, null, 2);
		} finally {
			this.pageLoaderService.close();
		}
	}
}

interface ToolRow {
	name:string;
	type: ToolType;
}
